/* vidi_panels_meta.js — shared per-sport vidi event toggle definitions.
 *
 * Source of truth for which event toggles each sport offers in the vidi
 * settings UI. Consumed by:
 *   - templates/settings.html (the rich Live Feed tab on /settings)
 *   - templates/widgets/vidi_options.html (the live dashboard's Vidi cog)
 *
 * Each entry: { id, label, toggles: [{key, label, desc, def?}], delta }
 *   - id     = sport_id we match against (lowercase). 'el' aliases for
 *              euroleague to keep keys short (vidi_el_*).
 *   - def    = what the board does when the key was never set (default
 *              true). Score-change bands and MLB routine plays are OFF by
 *              default - the scoreboard has its own Score Wire - so both
 *              controls must show them OFF until switched on, or the first
 *              click "does nothing" (Phase 5 settings review, 2026-10-11).
 *              Read it through vidiToggleOn() below, never `!== false`.
 *   - delta  = the "min FPts change" key; Off / 1 / 2 / 3 in both places.
 *
 * Team sports only: the individual-sport panels (tennis, MMA, golf, NASCAR)
 * were switches no code read, and none of those sports is live on
 * DraftKings - retired 2026-10-11. Add a sport here when its Wire really
 * filters on the keys.
 *
 * Xav 2026-06-06 — extracted from settings.js (formerly _SETTINGS_VIDI_PANELS)
 * so the live dashboard Vidi cog can surface the same toggles without
 * pulling in the entire ~1200-line settings page module.
 */
window.VIDI_SPORT_PANELS = [
  { id: 'nba',  label: 'NBA',  toggles: [
      { key: 'vidi_nba_match_events',  label: 'Match events', desc: 'Game started · halftime · final' },
      { key: 'vidi_nba_court_events',  label: 'On/off court', desc: 'Player substitution events' },
    ], delta: 'vidi_nba_min_delta' },
  { id: 'wnba', label: 'WNBA', toggles: [
      { key: 'vidi_wnba_match_events', label: 'Match events', desc: 'Game started · halftime · final' },
      { key: 'vidi_wnba_court_events', label: 'On/off court', desc: 'Player substitution events' },
    ], delta: 'vidi_wnba_min_delta' },
  { id: 'cbb',  label: 'CBB',  toggles: [
      { key: 'vidi_cbb_match_events',  label: 'Match events', desc: 'Game started · halftime · final' },
      { key: 'vidi_cbb_court_events',  label: 'On/off court', desc: 'Player substitution events' },
    ], delta: 'vidi_cbb_min_delta' },
  { id: 'nfl',  label: 'NFL',  toggles: [
      { key: 'vidi_nfl_match_events',  label: 'Match events', desc: 'Game started · quarter · final' },
    ], delta: 'vidi_nfl_min_delta' },
  { id: 'cfb',  label: 'CFB',  toggles: [
      { key: 'vidi_cfb_match_events',  label: 'Match events', desc: 'Game started · quarter · final' },
    ], delta: 'vidi_cfb_min_delta' },
  { id: 'nhl',  label: 'NHL',  toggles: [
      { key: 'vidi_nhl_match_events',  label: 'Match events', desc: 'Game started · period · final' },
      { key: 'vidi_nhl_onice_events',  label: 'On/off ice',   desc: 'Player substitution events' },
    ], delta: 'vidi_nhl_min_delta' },
  { id: 'mlb',  label: 'MLB',  toggles: [
      { key: 'vidi_mlb_match_events',  label: 'Inning events',  desc: 'Game started · inning change · final' },
      { key: 'vidi_mlb_routine',       label: 'Routine plays',  desc: 'Every at-bat outcome — outs, foul-outs, no-point plays', def: false },
    ], delta: 'vidi_mlb_min_delta' },
  { id: 'euroleague', label: 'Euroleague', toggles: [
      { key: 'vidi_el_match_events', label: 'Match events', desc: 'Game started · quarter · final' },
      { key: 'vidi_el_court_events', label: 'On/off court', desc: 'Player substitution events' },
    ], delta: 'vidi_el_min_delta' },
  { id: 'soccer', label: 'Soccer', toggles: [
      { key: 'vidi_soccer_match_events',   label: 'Match events',  desc: 'Game started · half time · full time' },
      { key: 'vidi_soccer_pitch_events',   label: 'Pitch events',  desc: 'Goals · cards · substitutions (live feed)' },
      { key: 'vidi_soccer_oncourt_events', label: 'On/off pitch',  desc: 'Player appearance events' },
    ], delta: 'vidi_soccer_min_delta' },
];

/** Is this Wire toggle on for these settings? Unset = the toggle's `def`. */
window.vidiToggleOn = function (settings, t) {
  const v = (settings || {})[t.key];
  return (v === undefined || v === null) ? t.def !== false : v !== false;
};
/** The min-change choices, the same on /settings and the board's cog. */
window.VIDI_MIN_DELTAS = [0, 1, 2, 3];
